import React, { Component } from "react";
import { analyticsFEA } from "src/AnalyticsFEA";
import { Appointment } from "Types/api/Appointment";
import { scheduleAppointmentToApi } from "./data";
import { buildAppointmentRequestBody, ContinueDealWithStateProps, validateSchedule } from "./lib";

export interface State {
    date: Date | null;
    time: Appointment["time"] | null;
    errorMessage: string | null | undefined;
}

const withState = (WrappedComponent: any) => {
    return class extends Component<ContinueDealWithStateProps, State> {
        constructor(props: any) {
            super(props);

            this.state = {
                date: props.appointmentDate,
                errorMessage: null,
                time: props.appointmentTime || undefined,
            };
        }
        public render() {
            return (
                <WrappedComponent
                    vehicle={this.props.vehicle}
                    selectedDate={this.state.date}
                    selectedTime={this.state.time}
                    setDate={this.setDate}
                    setTime={this.setTime}
                    schedule={this.schedule}
                    resetAppointment={this.resetAppointment}
                    onScheduleSuccess={this.onScheduleSuccess}
                    errorMessage={this.state.errorMessage}
                />
            );
        }

        private schedule = async (): Promise<any> => {
            const validation = validateSchedule(this.state.date, this.state.time);

            if (!validation.isValid) {
                this.setState({
                    errorMessage: validation.message,
                });
                return;
            } else {
                const request = buildAppointmentRequestBody(
                    this.state.date as Date,
                    this.state.time as Appointment["time"]
                );

                await this.scheduleAppointment(request);

                analyticsFEA.engine.appointmentScheduled(this.props.uuid, [this.props.vehicle]);
                this.props.history.push("/continue-deal/schedule-appointment");

                return true;
            }
        };

        private scheduleAppointment = async (request: any) => {
            if (request.date) {
                await scheduleAppointmentToApi(this.props.uuid, request);
            }
            this.props.scheduleAppointment(this.state.date as Date, this.state.time as Appointment["time"]);
        };

        private onScheduleSuccess = () => {
            analyticsFEA.engine.appointmentScheduled(this.props.uuid, [this.props.vehicle]);
            this.props.history.push("/continue-deal/schedule-appointment");
        };

        private setDate = (date: Date) => {
            this.setState({
                date,
                errorMessage: "",
            });
        };

        private setTime = (time: Appointment["time"]) => {
            this.setState({
                errorMessage: "",
                time,
            });
        };

        private resetAppointment = () => {
            this.setState(
                {
                    date: null,
                    errorMessage: "",
                    time: null,
                },
                () => {
                    this.props.removeAppointment();
                }
            );
        };
    };
};

export default withState;
